import 'objectFitPolyfill';
import Swiper from 'swiper';

import '../scss/bourget.scss';

document.addEventListener('DOMContentLoaded', () => {

    let slider = new Swiper('.slider', {
        loop: true,
        calculateHeight: true,
        updateOnImagesReady: true,
        autoplay: 5000,
        roundLengths: true,
        onSwiperCreated(slider) {
            let element = document.querySelector('section .pagination .max');
            if (element) {
                element.innerHTML = (slider.slides.length - 2).toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false,
                });
            }
        },
        onSlideChangeEnd(slider) {
            let element = document.querySelector('section .pagination .current');
            if (element) {
                element.innerHTML = (slider.activeLoopIndex + 1).toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false,
                });
            }
        },
    });
    
    if (document.querySelector('section .controls') != null) {

        document.querySelector('section .controls .prev').addEventListener('click', () => {
            slider.swipePrev();
        });

        document.querySelector('section .controls .next').addEventListener('click', () => {
            slider.swipeNext();
        });
    }

    document.querySelector('header .scroll').addEventListener('click', () => {
        window.scrollTo(0, window.innerHeight);
    });

    let message,
        jour;
    if (window.location.pathname.indexOf('/en/') > -1) {
        message = 'Le Bourget';
        jour = 'd';
    } else {
        message = 'Au salon du Bourget';
        jour = 'j';
    }

    let countDownDate = new Date('Jun 17, 2019 09:00:00').getTime();

    let x = setInterval(function () {
        let now = new Date().getTime();

        let distance = countDownDate - now;

        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

        document.getElementById('jours').innerHTML = '<span>' + days.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false,
        }) + '</span>' + jour;
        document.getElementById('heures').innerHTML = '<span>' + hours.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false,
        }) + '</span>h';
        document.getElementById('minutes').innerHTML = '<span>' + minutes.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false,
        }) + '</span>m';

        if (distance < 0) {
            clearInterval(x);
            document.querySelector('header .compteur').innerHTML = '<div>' + message + '</div>';
        }
    }, 1000);

});
